import React from 'react';

import cx from 'classnames';
import { useFormContext } from 'react-hook-form';

import { HookInput } from 'components/shared/HookFormComponents';
import Text from 'components/shared/Typography/Text';

import sharedStyles from '../../../../../shared/index.module.css';
import { NameSection, TagsSection } from '../../../shared';
import * as types from '../../../types';

function AboutUsForm() {
  const methods = useFormContext<types.AboutUsFormValues>();
  const { control } = methods;

  const deprecatedControl = control as any;

  return (
    <div>
      <NameSection nameInputPlaceholder="Company Name*" control={control}>
        I. Page Details
      </NameSection>

      <TagsSection methods={methods} />

      <div className={sharedStyles.headlineContainer}>
        <Text className={cx(sharedStyles.cssHeadline, sharedStyles.titleContainer)} type="brandon" isStrong>
          II. Emergency Contact
        </Text>
        <Text type="brandon" className={sharedStyles.descriptionText}>
          Add on the ground emergency contact for Agents to share with Guests.
        </Text>
      </div>

      <div className={cx(sharedStyles.gridFieldContainer, sharedStyles.adapterContainer)}>
        <div className={sharedStyles.gridSelectorContainer}>
          <HookInput name="emergencyContact.name" control={deprecatedControl} label="Name" />
        </div>

        <div className={sharedStyles.gridSelectorContainer}>
          <HookInput name="emergencyContact.phone" control={deprecatedControl} label="Phone" />
        </div>
      </div>

      <HookInput name="emergencyContact.email" control={deprecatedControl} label="Email" />
    </div>
  );
}

export { AboutUsForm };
